import { Button, Text, Inline, Stack, textVariants, vars } from '@etg/wings';
import { CaretDown } from '@phosphor-icons/react';
import { m as motion, AnimatePresence } from 'framer-motion';
import { css, cx } from '@eti/styles';
import { price as priceUtil } from '@eti/utils';
import { useSeatCharacteristicDisplay } from '../../hooks/useSeatCharacteristicDisplay';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const buttonStyles = css`
  border: 1px solid #e5e5e5;
  padding: 8px;

  > span {
    width: 100%;
  }
`;
const iconStyles = css`
  flex-shrink: 0;
  height: 32px;
  width: 32px;
`;
const rowStyles = css`
  flex: 1;
  justify-content: space-between;
`;
const iconTextStyles = css`
  max-width: 80%;
`;
const textStackStyles = css`
  gap: 0;
  text-align: start;
  width: inherit;
`;
const labelStyles = css`
  padding: 6px 0;
`;
const expandableContentStyles = css`
  display: grid;
  overflow: hidden;
`;
const motionVariantsOfContent = {
  enter: {
    height: 'auto',
    transition: {
      type: 'tween',
      duration: 0.3,
      when: 'beforeChildren'
    }
  },
  exit: {
    height: 0,
    transition: {
      type: 'tween',
      duration: 0.3,
      when: 'afterChildren'
    }
  }
};
const caretWrapperStyles = css`
  height: 32px;
  place-content: center;
`;
const caretStyles = {
  base: css`
    flex-shrink: 0;
  `,
  rotated: css`
    transform: rotate(180deg);
  `
};
const SeatCharacteristicsPanel = ({
  characteristic,
  isUnavailable,
  priceFrom,
  isOpen,
  onToggle
}) => {
  const {
    iconUrl,
    label,
    description,
    priceFromLabel
  } = useSeatCharacteristicDisplay(characteristic, isUnavailable);
  return /*#__PURE__*/_jsx(Button, {
    "aria-controls": "seat-characteristic-details",
    "aria-expanded": isOpen,
    className: buttonStyles,
    "data-testid": "seat-characteristic-panel",
    onClick: onToggle,
    children: /*#__PURE__*/_jsxs(Inline, {
      className: rowStyles,
      noWrap: true,
      spacing: 16,
      children: [/*#__PURE__*/_jsxs(Inline, {
        className: iconTextStyles,
        noWrap: true,
        spacing: 8,
        children: [iconUrl && /*#__PURE__*/_jsx("img", {
          alt: "",
          "aria-hidden": "true",
          className: iconStyles,
          src: iconUrl
        }), /*#__PURE__*/_jsxs(Stack, {
          className: textStackStyles,
          children: [/*#__PURE__*/_jsx(Text, {
            className: labelStyles,
            variant: textVariants._14_BOLD,
            children: label
          }), /*#__PURE__*/_jsx(AnimatePresence, {
            children: isOpen && /*#__PURE__*/_jsx(motion.div, {
              animate: "enter",
              className: expandableContentStyles,
              exit: "exit",
              id: "seat-characteristic-details",
              initial: "exit",
              variants: motionVariantsOfContent,
              children: /*#__PURE__*/_jsxs(Stack, {
                align: "start",
                spacing: 0,
                children: [!isUnavailable && /*#__PURE__*/_jsxs(Text, {
                  variant: textVariants._12,
                  children: [priceFromLabel, ": ", priceUtil.formatPrice(priceFrom)]
                }), /*#__PURE__*/_jsx(Text, {
                  variant: textVariants._12,
                  children: description
                })]
              })
            })
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: caretWrapperStyles,
        children: /*#__PURE__*/_jsx(CaretDown, {
          className: cx(caretStyles.base, {
            [caretStyles.rotated]: isOpen
          }),
          color: vars.colors.text.primary,
          "data-testid": "seatCharateristics-readMoreButtonIcon",
          size: 24,
          weight: "light"
        })
      })]
    })
  });
};
export default SeatCharacteristicsPanel;
//# sourceMappingURL=SeatCharacteristicsPanel.js.map